<script>
export let windGusts;
</script>

<div>
    Gusts: {windGusts} km/h
</div>